const HamburgerMenuConstants = [
    {
        title: 'Dashboard',
        icon: 'icon-dashboard',
        path: '/dashboard',
        useType: ['owner', 'agent'],
        roles: ['send', 'edit', 'view'],
    },
    {
        title: 'Campaigns',
        icon: 'icon-campaigns',
        roles: ['send', 'edit', 'view'],
        useType: ['owner', 'agent'],
        subMenu: [
            {
                title: 'Create',
                path: '/create-campaign',
                roles: ['send'],
            },
            {
                title: 'Scheduled',
                path: '/schedule-campaign',
                roles: ['send', 'edit', 'view'],
            },
            {
                title: 'Reports',
                path: '/campaign-report',
                roles: ['send', 'edit', 'view'],
            },
        ]
    },
    {
        title: 'Segmentation',
        icon: 'icon-segmentation',
        roles: ['send', 'edit'],
        useType: ['owner', 'agent'],
        subMenu: [
            {
                title: 'Segments',
                path: '/segments',
                keyword: 'segmentation',
                roles: ['send', 'edit']
            },
            {
                title: 'Topics',
                path: '/topics',
                keyword: 'topic',
                roles: ['send', 'edit']
            },
        ]
    },
    {
        title: 'Automation',
        icon: 'icon-automation',
        roles: ['send'],
        useType: ['owner', 'agent'],
        subMenu: [
            {
                title: 'Basic Automation',
                path: '/basic-automation',
                roles: ['send'],
            },
            {
                title: 'Shopify Automation',
                path: '/shopify-automation',
                keyword: 'shopify',
                roles: ['send', 'edit', 'view'],
                nestedRoutes: [
                    '/shopify-abandoned-cart',
                    '/shopify-back-in-stock',
                    '/shopify-price-drop',
                    '/shopify-shipping-notification',
                ]
            },
            {
                title: 'WooCommerce',
                path: '/woocommerce-automation',
                roles: ['send', 'edit', 'view'],
                nestedRoutes: [
                    '/woocommerce-abandoned-cart',
                    '/woocommerce-back-in-stock',
                    '/woocommerce-price-drop',
                    '/woocommerce-shipping-notification',
                ]
            },
        ]
    },
    {
        title: 'Subscribers',
        icon: 'icon-subscriber',
        path: '/subscribers',
        useType: ['owner', 'agent'],
        roles: ['send', 'edit', 'view'],
    },
    {
        title: 'Websites',
        icon: 'icon-website',
        useType: ['owner', 'agent'],
        roles: ['send', 'edit', 'view'],
        subMenu: [
            {
                title: 'Websites & Setup',
                path: '/websites-setup',
                roles: ['send', 'edit', 'view'],
            },
            {
                title: 'How to install',
                path: '/websites-integration',
                roles: ['send', 'edit'],
            },
            {
                title: 'Permission Prompt',
                path: '/permission-prompt',
                roles: ['send', 'edit'],
            },
        ]
    },
    {
        title: 'General Settings',
        icon: 'icon-settings',
        useType: ['owner'],
        roles: ['send', 'edit', 'view'],
        subMenu: [
            {
                title: 'User Management',
                path: '/user-management',
                keyword: 'user-management',
                roles: ['send', 'edit', 'view'],
            }
        ]
    },
];

export default HamburgerMenuConstants;